import { PredefinedCountry } from '/@/modules/predefined/enums/PredefinedCountry';
import {
  currencies,
  countries,
  activeCountries,
  jurisdictions
} from '@/modules/predefined/store/predefined.state';
import { Jurisdiction } from '@/modules/predefined/models/Jurisdiction';
import { Country } from '@/modules/predefined/models/Country';
import { Currency } from '@/modules/predefined/models/Currency';

export function getCurrencies(): Currency[] | undefined {
  return currencies.value;
}

export function getActiveCountries(): Country[] | undefined {
  return activeCountries.value;
}

export function getCountries(): Country[] | undefined {
  return countries.value;
}

export function getJurisdictions(): Jurisdiction[] | undefined {
  return jurisdictions.value;
}

export function isGenericJurisdiction(jurisdictionId: number): boolean | undefined {
  return jurisdictions.value?.find(
    (jurisdiction: Jurisdiction) => jurisdiction.id === jurisdictionId
  )?.isGeneric;
}

export function isCanadianJurisdiction(jurisdictionId: number): boolean | undefined {
  return (
    jurisdictions.value?.find((jurisdiction: Jurisdiction) => jurisdiction.id === jurisdictionId)
      ?.countryId === PredefinedCountry.CANADA.id
  );
}

export function isUSJurisdiction(jurisdictionId: number): boolean | undefined {
  return (
    jurisdictions.value?.find((jurisdiction: Jurisdiction) => jurisdiction.id === jurisdictionId)
      ?.countryId === PredefinedCountry.UNITED_STATES.id
  );
}
